// src/lib/supabase.js
// Replace with your actual Supabase URL and anon key
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

/*
=== SUPABASE SQL SCHEMA ===
Run this in your Supabase SQL editor to set up the database.

-- Profiles
create table profiles (
  id uuid references auth.users on delete cascade primary key,
  email text,
  full_name text,
  avatar_url text,
  position text,
  nationality text,
  date_of_birth date,
  is_admin boolean default false,
  last_seen_at timestamp with time zone,
  created_at timestamp with time zone default now()
);

-- Current Season
create table seasons (
  id uuid default gen_random_uuid() primary key,
  user_id uuid references profiles(id) on delete cascade,
  club_name text,
  league text,
  country text,
  season_label text,
  contract_start date,
  contract_end date,
  salary text,
  is_current boolean default true,
  created_at timestamp with time zone default now()
);

-- Match Log
create table matches (
  id uuid default gen_random_uuid() primary key,
  user_id uuid references profiles(id) on delete cascade,
  season_id uuid references seasons(id) on delete cascade,
  match_date date,
  opponent text,
  result text,
  started boolean default false,
  minutes_played int default 0,
  goals int default 0,
  assists int default 0,
  clean_sheet boolean default false,
  rating int check (rating >= 1 and rating <= 5),
  notes text,
  created_at timestamp with time zone default now()
);

-- Career History
create table career_history (
  id uuid default gen_random_uuid() primary key,
  user_id uuid references profiles(id) on delete cascade,
  club_name text,
  league text,
  country text,
  start_date date,
  end_date date,
  appearances int default 0,
  goals int default 0,
  assists int default 0,
  notes text,
  created_at timestamp with time zone default now()
);

-- Career Goals
create table career_goals (
  id uuid default gen_random_uuid() primary key,
  user_id uuid references profiles(id) on delete cascade,
  title text,
  target_date date,
  target_club text,
  target_league text,
  target_country text,
  notes text,
  status text default 'active',
  created_at timestamp with time zone default now()
);

-- Networking Log
create table networking (
  id uuid default gen_random_uuid() primary key,
  user_id uuid references profiles(id) on delete cascade,
  club_name text,
  contact_name text,
  contact_role text,
  country text,
  date_contacted date,
  method text,
  status text default 'pending',
  response text,
  notes text,
  follow_up_date date,
  created_at timestamp with time zone default now()
);

-- Enable RLS
alter table profiles enable row level security;
alter table seasons enable row level security;
alter table matches enable row level security;
alter table career_history enable row level security;
alter table career_goals enable row level security;
alter table networking enable row level security;

-- RLS Policies (users can only see their own data)
create policy "Users can view own profile" on profiles for all using (auth.uid() = id);
create policy "Users can manage own seasons" on seasons for all using (auth.uid() = user_id);
create policy "Users can manage own matches" on matches for all using (auth.uid() = user_id);
create policy "Users can manage own career history" on career_history for all using (auth.uid() = user_id);
create policy "Users can manage own goals" on career_goals for all using (auth.uid() = user_id);
create policy "Users can manage own networking" on networking for all using (auth.uid() = user_id);

-- === ADMIN SETUP ===
-- Run steps 1–4 in your Supabase SQL editor.

-- Step 1: Add columns (skip if already added)
alter table profiles add column if not exists is_admin boolean default false;
alter table profiles add column if not exists last_seen_at timestamp with time zone;

-- Step 2: Drop the old broken admin policies (the subquery on profiles caused
--         infinite recursion — querying profiles triggered its own RLS policy).
drop policy if exists "Admins can read all profiles" on profiles;
drop policy if exists "Admins can read all seasons" on seasons;
drop policy if exists "Admins can read all matches" on matches;

-- Step 3: Create a security-definer function to check admin status.
--         'security definer' runs as the function owner (bypasses RLS),
--         breaking the circular reference.
create or replace function public.is_admin()
returns boolean
language sql
security definer
stable
set search_path = public
as $$
  select coalesce(
    (select is_admin from profiles where id = auth.uid()),
    false
  )
$$;

-- Step 4: Recreate admin policies using the function (no more circular queries).
create policy "Admins can read all profiles" on profiles
  for select using (auth.uid() = id or public.is_admin());

create policy "Admins can read all seasons" on seasons
  for select using (auth.uid() = user_id or public.is_admin());

create policy "Admins can read all matches" on matches
  for select using (auth.uid() = user_id or public.is_admin());

-- Step 5: Grant yourself admin access (update your email below).
-- update profiles set is_admin = true where email = 'your@email.com';

-- Storage bucket for avatars
insert into storage.buckets (id, name, public) values ('avatars', 'avatars', true);
create policy "Avatar upload" on storage.objects for insert with check (bucket_id = 'avatars');
create policy "Avatar read" on storage.objects for select using (bucket_id = 'avatars');
*/
